import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { SalesBuzzParams } from '../../shared/Enums/SalesOrderParams';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private _appSettings;
  private appConfig;
  private currentURL;
  public clientId;
  public closeRow: boolean = true;
  checkResponse: boolean
  public handleReq = new Subject<Boolean>();

  constructor(private http: HttpClient, private _router: Router) { }

  async loadAppConfig() {

    var HttpHeader = { skip: "true" };
    await this.http.get('assets/data/appConfig.json', { headers: HttpHeader }).toPromise().then(data => { this._appSettings = data; }).catch(e => { console.log(e); });
    this.currentURL = window.location.origin;
    var csURL = "";
    var config = {};
    var Percision = 0;
    var isLocal: boolean = false;
    var clientId: string = '';
    var SignalREnabled: boolean = this._appSettings['SignalREnabled'];
    var BOURL: string = this._appSettings['BOAPIURL'];
    var REPORTURL: string = this._appSettings['REPORTURL'];
    var chatHubURL = this._appSettings['ChatHubURL'];
    var AdvancedWorkflowURL = this._appSettings['AdvancedWorkflowURL'];
    var MinWidthForDCard = this._appSettings['MinWidthForDCard'];
    var SalesBuzzApi = this._appSettings['SalesBuzzApiAppName'];
    var ChatAttachPath = this._appSettings['ChatAttachPath'];
    var ODataApi = this._appSettings['ODataURL'];
   // var ODataApi = "http://localhost:28576";
    var ReportMangerBaseURL = this._appSettings["ReportMangerBaseURL"];

    isLocal = this._appSettings['IsLocalEnvironment'];

    csURL = this.currentURL;

    var APIRootURL = "";
    if (SalesBuzzApi.toUpperCase().startsWith('HTTP')) //Check if full URL, or just AppName
      APIRootURL = SalesBuzzApi
    else
      APIRootURL = csURL + "/" + SalesBuzzApi
    if (!APIRootURL.endsWith("/"))
      APIRootURL = APIRootURL + "/";

    config = {
      "apiRoot": APIRootURL,
      "boURL": BOURL,//csURL + "/" + BOName + '/',
      "stsAuthority": csURL + "/SalesBuzzSTS/",
      "clientRoot": csURL + "/SalesBuzzUI/",// "SalesBuzzUI","SalesBuzzGamification" ,"SBUAT"
      "clientId": clientId,
      "ChatAttachPath": ChatAttachPath,
      "REPORTURL": REPORTURL,
      "Percision": Percision,
      "chatHub": chatHubURL,//"https://bifmcg.bi-technologies.net/CommunicationHubTwix/chathub",
      "oDataApi":   ODataApi,
      "ReportMangerBaseURL": ReportMangerBaseURL

    }
    if (location.href.includes("token")) {
      let token = location.href.split("token=")[1]
      localStorage.setItem("ODataToken", token)
      localStorage.setItem("jwt", token)
    }
    if (!config['apiKey'])
      await this.http.get(`${ODataApi}/VU_ConfigParams?$filter=Param_ID eq ${SalesBuzzParams.GoogleMapAPIKey}`, { headers: HttpHeader }).toPromise().then((data: any) => { config['apiKey'] = data.value[0].PARAM_VALUE; }).catch(e => { console.log(e); });

    this.appConfig = config;
    this.appConfig.appSettings = this._appSettings;
    Percision = 2; //parseInt((await this.getParamByID('38')) as any);
    //config.Percision = Percision;
    config['Percision'] = Percision;
    this.appConfig.Percision = Percision;

    return this.appConfig;
  }

  // please don`t use this Observable never
  getHandleRes(): Observable<any> {
    return this.handleReq.asObservable()
  }
  setHandleRes(response: boolean = true) {
    this.handleReq.next(response);
  }
  async getParamByID(ParamId) {
    var url = '';
    var api = '/api/parameters/GetParamValue?ParamId=' + ParamId;
    url = this.appConfig.oDataApi + api;
    /*
    var currentUrl = window.location.origin;
    if (currentUrl.includes('4200')) {
      url = 'http://localhost:56653/' + api;
    } else {
      url = currentUrl + '/' + this._appSettings['SalesBuzzApiAppName'] + '/' + api;
    }*/
    var x = await this.http.get(url)?.toPromise().catch(() => {
      this._router.navigate(["Error"]);
    });



    return x;
    //var xmlHttp = new XMLHttpRequest();
    //xmlHttp.open("GET", url, false); // false for synchronous request
    //xmlHttp.send(null);
    //return xmlHttp.responseText;
  }

  get ChatAttachPath(): string {
    return this.appConfig.ChatAttachPath;
  }
  get chatHub(): string {
    return this.appConfig.chatHub;
  }
  get apiRoot(): string {
    return this.appConfig.apiRoot;
  }
  get oDataApi(): string {
    if (this.appConfig)
      return this.appConfig.oDataApi;
    else
      return "ODATA Not Set";
  }
  get apiKey(): string {
    if (this.appConfig)
      return this.appConfig.apiKey;
  }
  set apiKey(apiKey) {
    if (this.appConfig)
      this.appConfig['apiKey'] = apiKey;
  }

  get Percision(): number {
    return this.appConfig.Percision;
  }
  get boURL(): string {
    return this.appConfig.boURL;
  }
  get REPORTURL(): string {
    return this.appConfig.REPORTURL;
  }
  get stsAuthority(): string {
    return this.appConfig.stsAuthority;
  }
  get clientRoot(): string {
    return this.appConfig.clientRoot;
  }
  get appSettings(): string {
    return this.appConfig.appSettings;
  }
  /* public getConfig() {
     return this.appConfig;
   }*/
  get SignalREnabled(): string {
    return this.appConfig.SignalREnabled;
  }
  get AdvancedWorkflowURL(): string {
    return this.appConfig.AdvancedWorkflowURL;
  }
  get MinWidthForDCard(): string {
    return this.appConfig.appSettings.MinWidthForDCard;
  }
  get GetReportMangerBaseURL(): string {
    return this.appConfig.ReportMangerBaseURL;
  }

}
